"use client";

import { useTheme } from "next-themes";
import { Toaster as Sonner, type ToasterProps } from "sonner";

const Toaster = ({ theme: propsTheme, ...props }: ToasterProps) => {
  const { theme: hookTheme } = useTheme();

  // Resolve theme with fallback - ensure it's never undefined
  let theme: "system" | "light" | "dark" = "system";
  if (
    propsTheme === "system" ||
    propsTheme === "light" ||
    propsTheme === "dark"
  ) {
    theme = propsTheme;
  } else if (
    hookTheme === "system" ||
    hookTheme === "light" ||
    hookTheme === "dark"
  ) {
    theme = hookTheme;
  }

  return (
    <Sonner
      className="toaster group"
      style={
        {
          "--normal-bg": "var(--popover)",
          "--normal-text": "var(--popover-foreground)",
          "--normal-border": "var(--border)",
        } as React.CSSProperties
      }
      theme={theme}
      {...props}
    />
  );
};

export { Toaster };
